// test43
(43 && 0);
